import { type TOC } from '@ember/component/template-only';

import BasicDropdown from 'ember-basic-dropdown/components/basic-dropdown';

import { getBem } from 'umg-ember-backend/utils/get-bem';

import { Directory } from './directory';
import styles from './styles.module.css';

const bem = getBem(styles);

interface DirectorySelectSignature {
  Args: {
    root: string;
    server: string;
    selected?: string;
    onSelect: (directory: string) => void;
  };
  Blocks: {
    default: [];
  };
  Element: HTMLDivElement;
}

<template>
  <div class={{(bem)}} ...attributes>
    <BasicDropdown @renderInPlace={{true}} as |dropdown|>
      <dropdown.Trigger
        class={{bem 'toggle'}}
        data-test-ui-directory-select-toggle
      >
        {{yield}}
      </dropdown.Trigger>

      <dropdown.Content class={{bem 'overlay'}}>
        <ul class={{bem 'root-directories'}}>
          <Directory
            @directory={{@root}}
            @server={{@server}}
            @isOpen={{true}}
            @showFullPath={{true}}
            @onSelect={{@onSelect}}
            @selected={{@selected}}
          />
        </ul>
      </dropdown.Content>
    </BasicDropdown>
  </div>
</template> satisfies TOC<DirectorySelectSignature>;
